import { Component } from "react";
import { DevHelper } from "../../../utils/DevHelper";

import ErrorState from "../states/errorstate";

interface IErrorBoundary {
    children: React.ReactNode;
    hideError?: boolean;
}

interface IErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundary, IErrorBoundaryState> {
    constructor(props: IErrorBoundary) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any) {
        DevHelper.print("error", error);
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        DevHelper.print("error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <ErrorState hideError={this.props.hideError} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;